import React, {PropTypes as T} from 'react';
import cx from 'classnames';

export default class Table extends React.Component {

    static propTypes = { 
        rows: T.array.isRequired,
        columns: T.array.isRequired,
        onSort: T.func,
        sorting: T.object,
        identityKey: T.string,
        expandedRows: T.array,
        expandedRowTemplate: T.func,
    };

    static defaultProps = { 
        onSort: () => {},
        expandedRows: [],
        expandedRowTemplate: () => {},
        sorting: null,
    };

    constructor(props) {
        super(props);
    }

    getSortBtn(column) {

        if (!this.props.sorting)
        {
            return null;
        }
        
        var {sortByKey, sortDescending} = this.props.sorting;

        if (column.key == sortByKey)
        {

            var classNames = cx(
                "b3-table-sort", 
                { "b3-table-sort-asc": !sortDescending },
                { "b3-table-sort-desc": sortDescending },
            );

            return (
                <span className={classNames}></span>
            )

        }

        return null;

    }
    renderCell(row, col) {

        if (col.dangerouslySetInnerHTML)
        {
            return null;
        }

        if (col.template)
        {
            return col.template(row, col.key, row[col.key], this.props.expandedRows.includes(row));
        }
        
        return row[col.key];
    }

    onColumnHeaderClicked(column) {

        if (!column.isSortable)
        {
            return;
        }

        var {sortByKey, sortDescending} = this.props.sorting;

        if (column.key == sortByKey)
        {
            this.props.onSort({
                sortByKey: sortByKey,
                sortDescending: !sortDescending,
            });

        }
        else
        {
            this.props.onSort({
                sortByKey: column.key,
                sortDescending: false,
            })
        }

    }

    getIdentityKey(row) {

        if (this.props.identityKey)
        {
            return row[this.props.identityKey];
        }
        else if (row.id)
        {
            return row.id;
        }
        else if (row.guid)
        {
            return row.guid;
        }
        else
        {
            return this.props.rows.findIndex(r => r === row);
        }

    }


    getWidthForColumn(column) {

        return column.width ? column.width : 'auto';

        //bla bla bla experimental
        
        // if (column.width.toString().slice(-1) == "*") {

        //     var combinedWidth = this.props.columns
        //         .filter(c => c.width && c.width.toString().slice(-1) == "*")
        //         .map(c => c.width.slice(0, -1))
        //         .reduce((p, c) => p + c , 0);


        //     //var combinedWidth = this.props.columns.map(c => c.width).reduce((p, c) => p + c , 0);

        //     var percent = column.width.slice(0, -1) / combinedWidth * 100;

        //     return percent + '%';

        // }
        // else {
        //     return column.width;
        // }


    }

    getCellStyles(row, col) {

        if (!this.props.cellStyles) {
            return {};
        }

        return this.props.cellStyles(row, col);
    }

    getRowClass(row) {
        return this.props.rows.indexOf(row) % 2 == 0 ? "b3-table-even" : "";
    }

    getCellClass(col) {
        return col.rightAlign ? "b3-table-right-align" : "";
    }

    getCellKey(row, col) {
        return [row.id, col.key].join();
    }

    renderRow(row) {

        var components = [];

        //the main row
        components.push(
            <tr className={this.getRowClass(row)} key={this.getIdentityKey(row)}>
                {this.props.columns.map(col => 

                    <td key={this.getCellKey(row, col)} className={this.getCellClass(col)} style={this.getCellStyles(row, col)}>
                        {this.renderCell(row, col)}
                    </td>

                )}
            </tr>
        );

        //the expandex
        if (this.props.expandedRows.includes(row)) {

            components.push(
                <tr className={this.getRowClass(row)}>
                    <td className="b3-table-expanded" colSpan={this.props.columns.length}>
                        {this.props.expandedRowTemplate(row)}
                    </td>
                </tr>
            );

        }

        return components;

    }

	render() {
        return (
            <table className="b3-table">

                <thead>
                    <tr>
                        {this.props.columns.map(col => 
                            <th key={col.key} style={{ width: this.getWidthForColumn(col) }}>

                                <div onClick={this.onColumnHeaderClicked.bind(this, col)}>

                                    <a>
                                        {col.title}
                                    </a>

                                    <div>
                                        {this.getSortBtn(col)}
                                    </div>

                                </div>

                            </th>
                        )}
                    </tr>
                </thead>

                {this.props.rows.length > 0 &&

                    <tbody>
                        {this.props.rows.map(row => 
                            this.renderRow(row)
                        )}
                    </tbody>
                }

                {this.props.rows.length == 0 &&
                    <tbody><tr><td style={{ textAlign: 'center' }} colSpan={this.props.columns.length}>No data available</td></tr></tbody>
                }

            </table>
        );
	}
}


// WEBPACK FOOTER //
// ./app/b3/tables/Table.js